import { render, staticRenderFns } from "./TotalAnsweredCalls.vue?vue&type=template&id=2237c8c5&scoped=true"
import script from "./TotalAnsweredCalls.vue?vue&type=script&lang=js"
export * from "./TotalAnsweredCalls.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2237c8c5",
  null
  
)

export default component.exports